export default {
  documents: [],
  document: {},
  total: 0,
  last_page: 0,
  open_edit: false,
  open_create_children: false,
  open_view: false,
  open_document: true
}



// WEBPACK FOOTER //
// ./src/store/module/document/state.js